import { IsInt } from 'class-validator';

export class AreaGetRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<AreaGetRequest>) {
        this.id = data && data.id;
    }
}
